import React from 'react';
import style from './index.module.scss';

export default class CombinedLabel extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: '',
        };
    }

    componentDidMount() {
        this.updateValue(this.props);
    }

    componentDidUpdate(prevProps) {

        /**
         * 只有 props 变化时才重新计算
         */
        if (
            JSON.stringify(prevProps.formData)
            !== JSON.stringify(this.props.formData)
            ||
            JSON.stringify(prevProps.combine_elements)
            !== JSON.stringify(this.props.combine_elements)
        ) {
            this.updateValue(this.props);
        }
    }

    /**
     * 更新 value
     */
    updateValue = (props) => {

        const combine_elements =
            props?.combine_elements ?? [];

        const value = combine_elements
            .reduce((pV, cV) => {

                const {
                    type,
                    value,
                } = cV;

                /**
                 * 静态文本
                 */
                if (type === "static") {
                    return pV.concat(value);
                }

                /**
                 * 表单字段
                 */
                if (type === "key") {

                    let concatValue =
                        props.addons?.getValue?.(value)
                        || '';

                    if (
                        value === "day"
                        && typeof concatValue === 'string'
                    ) {
                        concatValue =
                            concatValue.replaceAll('-', '');
                    }

                    return pV.concat(concatValue);
                }

                return pV;

            }, [])
            .join("");

        /**
         * 避免重复 setState
         */
        if (value !== this.state.value) {

            this.setState({
                value,
            });

        }

        /**
         * 避免重复 onChange
         */
        if (value !== props.value) {

            props.onChange?.(value);

        }
    }

    render() {

        const { value } = this.state;

        return (
            <div className={style['wrapper']}>
                {value}
            </div>
        );
    }
}